// frontend/packages/business-console/src/services/reportRecipientsService.js
//
// Client for /api/v2/report-recipients (Settings > Report emails): the
// addresses that get the scheduled lead report. Reads for every role; writes
// are businessadmin only (the server enforces it). Per-tenant feature
// `report_emails`: list returns { enabled: false } when it is off.

import { api } from '@upryzze/services';

/**
 * @returns {Promise<{ enabled: boolean, maxRecipients?: number,
 *   recipients?: Array<{ id, email, frequency, status, confirmedAt,
 *   confirmSentAt, lastSentAt, createdAt }> }>}
 */
export async function listReportRecipients() {
  const { data } = await api.get('/v2/report-recipients');
  return data || { enabled: false };
}

export async function addReportRecipient({ email, frequency }) {
  const { data } = await api.post('/v2/report-recipients', {
    email,
    frequency,
  });
  return data;
}

export async function updateReportRecipient(id, { frequency }) {
  const { data } = await api.patch(`/v2/report-recipients/${id}`, {
    frequency,
  });
  return data;
}

export async function removeReportRecipient(id) {
  const { data } = await api.delete(`/v2/report-recipients/${id}`);
  return data;
}

export async function resendReportConfirmation(id) {
  const { data } = await api.post(`/v2/report-recipients/${id}/resend`);
  return data;
}
